"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgMushroom = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M10 16.75a.75.75 0 011.5 0v.5a.75.75 0 01-1.5 0v-.5zM13.25 16a.75.75 0 00-.75.75v.5a.75.75 0 001.5 0v-.5a.75.75 0 00-.75-.75z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M22 11c0 3.272-1.571 4.773-4 5.453v.047c0 2.13 0 5.5-6 5.5s-6-3.37-6-5.5v-.047c-2.429-.68-4-2.181-4-5.453 0-5.523 4.477-9 10-9s10 3.477 10 9zm-7-2a3 3 0 11-6 0 3 3 0 016 0zm4.949 2.888c-.357 1.334-1.296 2.241-2.096 2.027-.8-.214-1.16-1.47-.802-2.803.358-1.334 1.296-2.241 2.096-2.027.8.215 1.16 1.47.802 2.803zM6.743 13.915c.8-.215 1.16-1.47.802-2.803-.357-1.334-1.296-2.241-2.096-2.027-.8.215-1.16 1.47-.802 2.803.357 1.334 1.296 2.241 2.096 2.027zm8.85 5.013c.353-.521.407-1.259.407-2.428 0-.093-.029-.408-.735-.804C14.554 15.297 13.414 15 12 15c-1.414 0-2.554.297-3.265.696-.706.396-.735.711-.735.804 0 1.17.054 1.907.407 2.428C8.637 19.27 9.35 20 12 20s3.362-.73 3.594-1.072z' }))); };
exports.default = SvgMushroom;
//# sourceMappingURL=Mushroom.js.map